/**
 * NAVIGATION
 * Nav-related behavioral enhancements.
 * - Burger menu toggle
 * - Mobile nav open/close
 *
 * Add dropdown, mega-menu, or other nav behaviors here
 * as the project requires.
 */

export function init() {

  // ---------------------------------------------------------
  // BURGER TOGGLE
  // ---------------------------------------------------------

  const burger = document.querySelector('._burger');
  if (!burger) return;

  const nav = document.querySelector('._nav.-main');

  burger.addEventListener('click', (e) => {
    e.preventDefault();

    const isActive = burger.classList.toggle('-active');
    burger.setAttribute('aria-expanded', isActive);

    if (nav) nav.classList.toggle('-active');
  });
}
